import type { DocumentSelectionRequest, SelectedDocument } from './documentSelectionTypes';

export type DocumentSelectionServiceDeps = {
  requestSelection: (request: DocumentSelectionRequest) => Promise<SelectedDocument | null>;
};

export type DocumentSelectionService = {
  requestDocument: (request: DocumentSelectionRequest) => Promise<SelectedDocument | null>;
};

/**
 * Document Selection Service — opens picker (via injected bridge) and returns selection or cancel.
 * Domain-agnostic: no Replace / Manual / Initialize knowledge.
 */
export function createDocumentSelectionService(
  deps: DocumentSelectionServiceDeps
): DocumentSelectionService {
  return {
    requestDocument: (request) => deps.requestSelection(request),
  };
}
